<template>
  <div id="sign-layer">
    <header>
      <div class="header-center">
        <a href="https://www.yuanquanyun.com.cn/"><img src="../../assets/images/login/new-logo.png" class="logo" alt="" />
        </a>
        <!-- <span class="logo-text">元全云电子合同</span> -->
        <span class="logo-s-title"></span>
      </div>
    </header>
    <div class="setcontrol-content" id="main">
      <div class="set-sign-control" id="set-sign">
        <div class="set-title">选择签章签署</div>
        <div class="select-sign">
          <p class="select-sign-title">选择以下签章拖拽至签署区域</p>
          <div class="sign-list">
            <!-- <div class="sign-default">
              <p class="sign-default-title">默认签章</p>
              <div class="default-box">
                <img :data-signid="signImgs[0].id" v-drop="{setSignId}" :src="signImgs[0].sealData" alt="">
              </div>
              <p class="sign-name">{{signImgs[0].sealName}}</p>
            </div> -->
            <el-tooltip class="item" :value="true" effect="dark" content="选择以下签章拖拽至签署区域进行签章" placement="right">
              <p class="orther-title">选择签章</p>
            </el-tooltip>
            <div class="orther-list">
              <div class="sign-orther" v-for="sign in signImgs" :key="sign.id">
                <!-- {{sign}} -->
                <div class="orther-box">
                  <div class="orther-sign-box">
                    <div class="drag-box" :data-sealId="sign.sealId" v-drop>
                      <img class="orther-box-sign" :src="sign.sealData" alt="" />
                    </div>
                  </div>
                  <img v-if="sign.sealType == '0'" src="../../assets/images/sign/personal.png" class="type-icon" alt="" />
                  <img v-if="sign.sealType == '1'" src="../../assets/images/sign/company.png" class="type-icon" alt="" />
                  <img v-if="sign.sealType == '2'" src="../../assets/images/sign/legal.png" class="type-icon" alt="" />
                </div>
                <!-- <p class="sign-auth" :class="{'default': !sign.isAuthName}">{{sign.isAuthName}}</p>
								<p class="sign-name">{{sign.sealName}}</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="contract-content" ref="cmain">
        <div class="contract-img-content">
          <div ref="contract" style="
                text-align: center;
                border-bottom: 10px solid #eee;
                box-sizing: content-box;
                -ms-box-sizing: content-box;
              " v-if="hrefFrom == 'sxzxsl'">
            <span style="
                  width: 100%;
                  font-size: 20px;
                  text-align: center;
                  margin-top: -100px;
                ">
              <font>山西CA与正元安服联合品牌正元签，一站式在线签约平台</font>
            </span>
          </div>

          <div class="contract-imgs" id="contract-imgs" ref="contract">
            <div class="img-wrap" v-for="(contract, index) in contractImgs" :key="index" ref="imgWrap">
              <img :src="contract.src" class="contract-img" alt="" />
            </div>
          </div>

          <!-- <div v-show="showCustom" class="custom-drag" :data-subject="drag.sealSubject" :data-page="drag.page" v-for="drag in positionList" :key="drag.createdId" :style="{left: drag.left * 685+'px', top: drag.top*contractH + (drag.page-1)*contractH +'px'}" :data-cid="drag.createdId" v-maxIndex>
						<div class="custom-content"></div>
						<span class="custom-drag-title" v-show="!drag.signImg">{{drag.sealType}}章</span>
						<div class="custom-drag-header clearfix">
							<span style="float: left;">{{drag.isPaging == '0'?'普通章':'骑缝章'}}</span>
							<span class="delete" @click="deleteSeal(drag.createdId)">X</span>
						</div>
						<div class="custom-sign-box">
							<img :src="drag.signImg" alt="">
						</div>
					</div> -->

          <!-- <img :style="{left: date.left * 685+'px', top: date.top*contractH + (date.page-1)*contractH +'px', position: 'absolute', display: 'block', width: '127px', zIndex: '99'}" v-for="(date, index) in dateList" :key="index" :src="date.src" alt=""> -->
        </div>
      </div>

      <div class="contract-page">
        <div class="all-page">
          <div class="page-item" v-for="(contract, index) in contractImgs" :key="index">
            <div class="page-img" @click="jumpPage(index)">
              <img :src="contract.src" alt="" />
              <img v-if="contract.isSign" :src="iconImgs[parseInt(contract.isSign) - 1]" class="sign-icon" alt="" />
            </div>
            <p class="page-text">第{{ index + 1 }}页</p>
          </div>
        </div>
      </div>
    </div>
    <div class="submit-btn clearfix" v-show="contractImgs.length > 0">
      <!-- <el-button type="primary" class="submit" @click="returnHandle">退回</el-button> -->
      <el-button type="primary" class="submit" @click="authHandle">完 成</el-button>
    </div>

    <sign-auth ref="auth" @getAuthCode="getAuthCodeHandle" :mode="['pin']"></sign-auth>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import signAuth from "./sign-auth";
import eHeader from "@/components/eHeader";
import { getContractImgsApi } from "@/api/sign/flow";
import {
  getContractPositionApi,
  signSealApi,
  returnContractApi,
  autoLoginByTokenApi,
  getDatePngSrcApi,
  getCompanyLegalApi,
  getSealListApi,
  getContractApi,
  signSealOpenApi,
} from "@/api/sign/sign";
import { getUserSealInfoApi } from "@/api/common";
import { getCompanySealInfoApi } from "@/api/space/signatures";
import { getToken, setToken, removeToken } from "@/utils/auth";
import { lang } from "moment";
import { mapState } from "vuex";
export default {
  components: {
    eHeader,
    signAuth,
  },
  directives: {
    drop: {
      inserted: function (el, binding, vnode) {
        var disX = 0;
        var disY = 0;
        var contractImgs =
          document.querySelector("#contract-imgs").parentNode.parentNode;
        var contractDom = document.querySelector("#contract-imgs");
        var main = document.querySelector("#main");
        var setSign = document.querySelector("#set-sign");
        var customDrags;
        var signId = "";
        var sealSubject; // 章类型
        var posSubject; // 需要的章类型

        // 获取所有图片，拖拽不在浏览器新页面打开
        Array.from(document.getElementsByTagName("img")).forEach((img) => {
          img.ondragstart = function () {
            return false;
          };
        });

        el.onmousedown = function () {
          customDrags = document.querySelectorAll(".custom-drag");
          // el.style.background = '#ccc';
          var event = event || window.event;
          disX = event.clientX - this.offsetLeft;
          disY = event.clientY - this.offsetTop + setSign.scrollTop;
          var cloneTemp = el.cloneNode(true);
          cloneTemp.style.position = "fixed";
          cloneTemp.style.zIndex = 999;
          cloneTemp.style.left = this.currentStyle
            ? this.currentStyle["left"]
            : getComputedStyle(this, null)["left"];
          // cloneTemp.style.top = this.currentStyle ? this.currentStyle["top"] : getComputedStyle(this, null)["top"];
          cloneTemp.style.top = event.clientY - disY + main.offsetTop + "px";
          cloneTemp.style.cursor = "grab";
          cloneTemp.style.opacity = ".4";

          signId = el.getAttribute("data-signid");
          sealSubject = el.getAttribute("data-subject");
          // signId = el.dataset.signid || getDataset(el).signid

          el.parentNode.appendChild(cloneTemp);

          document.onmousemove = function (event) {
            var event = event || window.event;
            var iL = event.clientX - disX;
            var iT = event.clientY - disY;
            var maxL = document.documentElement.clientWidth - el.offsetWidth;
            var maxT = document.documentElement.clientHeight - el.offsetHeight;
            iL <= 0 && (iL = 0);
            iT <= 0 && (iT = 0);
            iL >= maxL && (iL = maxL);
            iT >= maxT && (iT = maxT);

            cloneTemp.style.left = iL + main.offsetLeft + "px";
            // console.log(iT)
            cloneTemp.style.top = iT + main.offsetTop + "px";

            // console.log(cloneTemp.style.top)
            // console.log(cloneTemp.style.left)
            return false;
          };

          document.onmouseup = function (event) {
            var event = event || window.event;
            document.onmousemove = null;
            document.onmouseup = null;

            var event = event || window.event;

            let targetTop = +cloneTemp.style.top.split("px")[0];
            let targetLeft = +cloneTemp.style.left.split("px")[0];
            const targetWidth = +cloneTemp.offsetWidth;
            const targetHeight = +cloneTemp.offsetHeight;
            document.onmousemove = null;
            document.onmouseup = null;

            let contractDomLeft = contractDom.getBoundingClientRect().left;
            let contractDomTop = contractDom.getBoundingClientRect().top;

            if (
              targetLeft >= contractDomLeft &&
              targetLeft <=
              contractDomLeft + contractDom.offsetWidth - targetWidth &&
              targetTop >= contractDomTop &&
              targetTop <=
              contractDomTop + contractDom.offsetHeight - targetHeight
            ) {
              targetTop = targetTop - contractDomTop;
              targetLeft = targetLeft - contractDomLeft;
              cloneTemp.style.position = "absolute";
              cloneTemp.style.left = targetLeft + "px";
              cloneTemp.style.top = targetTop + "px";
              cloneTemp.style.opacity = "1";
              const pageHeight =
                contractDom.querySelectorAll(".contract-img")[0].offsetHeight;
              vnode.context.judgePage(
                cloneTemp,
                targetTop,
                pageHeight,
                targetHeight
              );

              const deleteDom = document.createElement("i");
              deleteDom.setAttribute(
                "class",
                "el-icon-circle-close delete-icon"
              );
              deleteDom.addEventListener("click", function () {
                cloneTemp.parentNode.removeChild(cloneTemp);
              });

              cloneTemp.appendChild(deleteDom);
              contractDom
                .querySelectorAll(".img-wrap")
              [cloneTemp.getAttribute("data-page")].appendChild(cloneTemp);
            } else {
              el.parentNode.removeChild(cloneTemp);
            }
          };
        };
      },
    },
    maxIndex: {
      inserted: function (el, binding) {
        var customDrags = document.getElementsByClassName("custom-drag");
        el.onclick = function () {
          for (var i = 0; i < customDrags.length; i++) {
            customDrags[i].style.zIndex = 9;
          }
          el.style.zIndex = 9999;
        };
      },
    },
  },
  computed: {
    ...mapState(["companyList", "currentSpace"]),
  },
  mounted() {
    const _this = this;
    let disX = 0;
    let disY = 0;
    const receiverDom = document.querySelector("#contract-imgs");
    // const setHandlerDom = document.querySelector("#set-handler");
    receiverDom.onmousedown = () => {
      const event = event || window.event;
      if (event.target.classList.contains("delete-icon")) {
        return;
      }
      const target = event.target.parentNode;
      const offsetLeft = target.offsetLeft;
      const offsetTop = target.offsetTop;
      disX = event.clientX;
      disY = event.clientY;
      if (target.className === "drag-box") {
        document.onmousemove = function (event) {
          const event2 = event || window.event;
          let iL = event2.clientX - disX + offsetLeft;
          let iT = event2.clientY - disY + offsetTop;

          const maxL = receiverDom.offsetWidth - target.offsetWidth;
          const maxT = receiverDom.offsetHeight - target.offsetHeight;
          iL <= 0 && (iL = 0);
          // iT <= 0 && (iT = 0);
          iL >= maxL && (iL = maxL);
          iT >= maxT && (iT = maxT);
          target.style.left = iL + "px";
          target.style.top = iT + "px";
          target.getElementsByClassName("delete-icon")[0].style.display =
            "none";
          return false;
        };
        document.onmouseup = function (event) {
          const event3 = event || window.event;
          const pageHeight = receiverDom.children[0].offsetHeight;
          _this.judgePage(
            target,
            +target.style.top.split("px")[0],
            pageHeight,
            target.offsetHeight
          );

          receiverDom
            .querySelectorAll(".img-wrap")
          [target.getAttribute("data-page")].appendChild(target);
          target.getElementsByClassName("delete-icon")[0].style = "";
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    };

    // this.getDatePngSrcHandle()
    // this.getUserSealInfoHandle()
    // getSealListApi().then(res => {});
  },
  created() {
    let token = this.$route.query.token;
    if (getToken()) {
      removeToken();
    }
    setToken(token, 1);
    this.getSealListHandle();
    this.getContractHandle();
  },
  watch: {},
  data() {
    return {
      showTip: true,
      showCustom: false,
      contractH: null,
      setContractH: null,
      contractImgs: [],
      selectId: "",
      signImgs: [],
      iconImgs: [
        require("../../assets/images/sign/sign-icon.png"),
        require("../../assets/images/sign/sign-icon2.png"),
      ],
      stitle: " ",
      isTime: "0",
      scrollTop: 0,
      signatoryId: 456,
      renderOK: false,
      positionList: [],
      sealList: [],
      code: "",
      pin: "",
      approvalNum: 0,
      hrefFrom: this.$route.query.hrefFrom,
      dateList: [],
      dateSrc: "",
    };
  },
  methods: {
    // 判定落在哪页
    judgePage(target, targetTop, pageHeight, offsetHeight) {
      let gutterHeight = 0;
      if (document.querySelectorAll(".img-wrap")[1]) {
        gutterHeight = +window
          .getComputedStyle(document.querySelectorAll(".img-wrap")[1], null)
          .marginTop.split("px")[0];
      }
      // 判定范围
      const judgeScope = (offsetHeight - gutterHeight) / 2 + gutterHeight;
      const judgeExpression =
        targetTop -
        (Math.ceil(targetTop / (pageHeight + gutterHeight)) *
          (pageHeight + gutterHeight) -
          (gutterHeight + offsetHeight) / 2);
      // 多页计算

      let divider = target.getAttribute("data-page")
        ? +target.getAttribute("data-page")
        : 0;

      divider += Math.floor(targetTop / (pageHeight + gutterHeight));

      if (divider < 0) {
        divider = 0;
        target.style.top = 0;
      } else {
        if (Math.abs(judgeExpression) < judgeScope) {
          // 进入判定范围
          const nextPageHeight =
            (pageHeight + gutterHeight) *
            Math.ceil(targetTop / (pageHeight + gutterHeight));
          if (judgeExpression <= 0) {
            // 移到上一页
            target.style.top = pageHeight - offsetHeight + "px";
          } else {
            // 移到下一页
            target.style.top = 0 + "px";
            divider++;
          }
        } else {
          target.style.top =
            ((pageHeight + gutterHeight + targetTop) %
              (pageHeight + gutterHeight)) +
            "px";
        }
      }

      if (divider > this.contractImgs.length - 1) {
        divider = this.contractImgs.length - 1;
        target.style.top = pageHeight - offsetHeight + "px";
      }

      target.setAttribute("data-page", divider);
    },
    getContractHandle() {
      getContractApi({
        contractId: this.$route.query.contractId,
      })
        .then((res) => {
          if (res.code != "200") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            let imgArr = res.result.pngList.map((el) => {
              return el + "&nocache=" + new Date().getTime();
            });

            imgArr.forEach((img) => {
              this.contractImgs.push({
                isSign: "",
                src: img,
              });
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSealListHandle() {
      getSealListApi().then((res) => {
        if (res.code != "200") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          // let sealList = []
          res.result.sealList
            .map((el) => {
              el.sealSubject = 1;
              return el;
            })
            .forEach((seal) => {
              this.signImgs.push(seal);
            });

          // this.getCompanyLegalHandle();
        }
      });
    },
    getContractPositionHandle() {
      getContractPositionApi({
        contractId: this.$route.query.contractId,
        signingBody: this.$route.query.signType || 0,
        companyId: this.$route.query.companyId || "",
      })
        .then((res) => {
          if (res.code !== "0") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            res.result.positionList.forEach((pos) => {
              var sealType;
              var sealSubject; // 0是个人，1是经办人。2是企业
              if (pos.sealSubject == "0") {
                sealType = "个人";
                sealSubject = 0;
              }

              if (this.$route.query.companyId && pos.sealSubject == "1") {
                sealType = "经办人";
                sealSubject = 0;
              }

              if (pos.sealSubject == "2") {
                sealType = "企业";
                sealSubject = 1;
              }

              if (pos.sealSubject == "3") {
                sealType = "时间";
                sealSubject = 3;
              }

              if (pos.sealSubject == "4") {
                sealType = "法定代表人";
                sealSubject = 4;
              }

              if (pos.sealSubject != "3") {
                this.positionList.push({
                  sealType: sealType,
                  isPaging: pos.sealType,
                  left: pos.x,
                  top: pos.y,
                  page: pos.page,
                  createdId: pos.id,
                  signId: "",
                  signImg: "",
                  sealSubject: sealSubject,
                });
              } else {
                this.dateList.push({
                  left: pos.x,
                  top: pos.y,
                  page: pos.page,
                  src: this.dateSrc,
                });

                console.log(this.dateList);
              }
            });

            this.getContractImgsHandle();
          }

          this.$nextTick(function () {
            this.renderOK = true;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUserSealInfoHandle() {
      getUserSealInfoApi().then((res) => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          res.result.sealList
            .map((el) => {
              el.sealData =
                ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) +
                el.sealData +
                getToken() +
                "&nocache=" +
                new Date().getTime();
              el.sealSubject = "0";
              el.isAuthName = "";
              return el;
            })
            .forEach((seal) => {
              this.signImgs.push(seal);
            });

          if (this.$route.query.companyId) {
            this.getCompanySealInfoHandle();
          }
        }
      });
    },
    getCompanySealInfoHandle() {
      getCompanySealInfoApi({
        companyId: this.$route.query.companyId,
      }).then((res) => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          // let sealList = []
          res.result.sealList
            .map((el) => {
              el.sealData =
                ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) +
                el.sealData +
                getToken() +
                "&nocache=" +
                new Date().getTime();
              el.sealSubject = 1;
              // el.isAuthName =
              if (el.isAuth == "1") {
                el.isAuthName = "已授权";
              } else {
                el.isAuthName = "需审批";
              }
              return el;
            })
            .forEach((seal) => {
              this.signImgs.push(seal);
            });

          this.getCompanyLegalHandle();
        }
      });
    },
    getCompanyLegalHandle() {
      getCompanyLegalApi({
        companyId: this.$route.query.companyId,
        nochche: new Date().getTime(),
      }).then((res) => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          // let sealList = []
          res.result.sealList
            .map((el) => {
              el.sealData =
                ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) +
                el.sealData +
                getToken() +
                "&nocache=" +
                new Date().getTime();
              el.sealSubject = 4;
              // el.isAuthName =
              if (el.isAuth == "1") {
                el.isAuthName = "已授权";
              } else {
                el.isAuthName = "需审批";
              }
              return el;
            })
            .forEach((seal) => {
              this.signImgs.push(seal);
            });

          // this.getCompanyLegalHandle()
        }
      });
    },
    getContractImgsHandle() {
      getContractImgsApi(this.$route.query.contractId)
        .then((res) => {
          if (res.code !== "0") {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            let imgArr = res.result.pngList.map((el) => {
              return (
                ((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API) ? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) +
                el +
                getToken() +
                "&nocache=" +
                new Date().getTime()
              );
            });

            imgArr.forEach((img) => {
              this.contractImgs.push({
                isSign: "",
                src: img,
              });
            });

            if (this.contractImgs.length > 0) {
              this.contractImgs.forEach((img, index) => {
                if (this.positionList.length > 0) {
                  this.positionList.forEach((pos) => {
                    if (index + 1 == pos.page) {
                      this.$nextTick(function () {
                        img.isSign = "1";
                      });
                    }
                  });
                }
              });
              this.$nextTick(() => {
                this.contractH =
                  document.querySelector(
                    "#contract-imgs"
                  ).children[0].offsetHeight;
                // console.log('签署时height：'+this.contractH)
                // console.log('签署时width：'+document.querySelector('#contract-imgs').children[0].offsetWidth)
                var _this = this;
                document.querySelector("#contract-imgs").children[0].onload =
                  function () {
                    _this.setContractH = setInterval(() => {
                      _this.contractH =
                        document.querySelector(
                          "#contract-imgs"
                        ).children[0].offsetHeight;
                    }, 500);
                  };
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDatePngSrcHandle() {
      getDatePngSrcApi().then((res) => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: "warning",
          });
        } else {
          this.dateSrc = res.result.imgBase64;
          this.getContractPositionHandle();
        }
      });
    },
    back() {
      if (this.$route.query.companyId) {
        // 企业
        this.companyList.forEach((company) => {
          if (company.companyId == this.$route.query.companyId) {
            this.$store.commit("SET_CURRENT_SPACE", company);
          }
        });
        this.$router.push({
          path: "/company-space/contracts",
          query: {
            status: "all",
            companyId: this.$route.query.companyId,
          },
        });
      } else {
        // 个人
        this.$store.commit("SET_CURRENT_SPACE", {});
        this.$router.push({
          path: "/user-space/contracts",
          query: {
            status: "all",
          },
        });
      }
    },
    setSignId(sid, cid, posSubject, sealSubject) {
      var signImg;
      var pageSeals = [];

      if (posSubject !== sealSubject) {
        if (sealSubject == 0) {
          this.$message({
            showClose: false,
            message: "请拖至个人或经办人签署框内！",
            type: "warning",
          });

          return;
        }

        if (sealSubject == 1) {
          this.$message({
            showClose: false,
            message: "请拖至企业签署框内！",
            type: "warning",
          });

          return;
        }

        if (sealSubject == 4) {
          this.$message({
            showClose: false,
            message: "请拖至法定代表人签署框内！",
            type: "warning",
          });

          return;
        }
      }

      this.signImgs.forEach((item) => {
        if (item.id == sid) {
          signImg = item.sealData;
        }
      });

      this.positionList.forEach((item) => {
        if (item.createdId == cid) {
          item.signId = sid;
          item.signImg = signImg;
        }
      });

      for (var i = 0; i < this.contractImgs.length; i++) {
        for (var j = 0; j < this.positionList.length; j++) {
          if (i + 1 == this.positionList[j].page) {
            if (!this.positionList[j].signImg) {
              this.contractImgs[i].isSign = "1";
              break;
            } else {
              this.contractImgs[i].isSign = "2";
            }
          }
        }
      }
    },
    deleteSeal(id) {
      this.positionList.forEach((pos) => {
        if (pos.createdId === id) {
          pos.signId = "";
          pos.signImg = "";
        }
      });

      for (var i = 0; i < this.contractImgs.length; i++) {
        for (var j = 0; j < this.positionList.length; j++) {
          if (i + 1 == this.positionList[j].page) {
            if (!this.positionList[j].signImg) {
              this.contractImgs[i].isSign = "1";
              break;
            } else {
              this.contractImgs[i].isSign = "2";
            }
          }
        }
      }
    },
    jumpPage(page) {
      var sTop = 0;
      var allImgs = this.$refs.contract.querySelectorAll("img");
      for (var i = 0; i < page; i++) {
        sTop += allImgs[i].offsetHeight;
      }
      this.$refs.cmain.scrollTop = sTop;
    },
    authHandle() {
      // this.sealList = [];
      var bOk = true;
      // this.positionList.forEach(pos => {
      // 	this.sealList.push({
      // 		sealId: pos.signId,
      // 		positionId: pos.createdId
      // 	});
      // });

      // for (var i = 0; i < this.sealList.length; i++) {
      // 	if (!this.sealList[i].sealId) {
      // 		bOk = false;
      // 		this.$message({
      // 			showClose: false,
      // 			message: "当前合同尚未完成签署，请选择印章签署后再提交",
      // 			type: "warning"
      // 		});

      // 		break;
      // 	}
      // }

      if (bOk) {
        this.$refs.auth.dialogVisible = true;
      }
    },
    getAuthCodeHandle(data) {
      if (data.type == "sms") {
        this.code = data.code;
        this.pin = "";
      } else {
        this.code = "";
        this.pin = data.code;
      }

      this.signSealHandle();
    },
    signSealHandle() {
      if (!document.querySelectorAll(".contract-img")[0]) {
        return;
      }
      let loadingInstance = Loading.service({
        fullscreen: true,
      });
      let positionLocationList = [];

      let contractWidth =
        +document.querySelectorAll(".contract-img")[0].offsetWidth;
      let contractHeight =
        +document.querySelectorAll(".contract-img")[0].offsetHeight;
      this.$refs.contract.querySelectorAll(".drag-box").forEach((item) => {
        positionLocationList.push({
          sealId: item.getAttribute("data-sealid"),
          pageIndex: +item.getAttribute("data-page") + 1,
          positionX: parseInt(
            (+item.style.left.split("px")[0] / contractWidth) * 100
          ),
          positionY: parseInt(
            (+item.style.top.split("px")[0] / contractHeight) * 100
          ),
        });
      });

      signSealOpenApi({
        contractId: this.$route.query.contractId,
        pin: this.pin,
        positionLocationList: positionLocationList,
      })
        .then((res) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
          if (res.code != 200) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "warning",
            });
          } else {
            this.$message({
              message: "签署成功！",
              type: "success",
            });
          }
        })
        .catch((err) => {
          this.$nextTick(() => {
            loadingInstance.close();
          });
          console.log(err);
        });
    },
    returnHandle() {
      this.$confirm("确认要退回吗？", "温馨提示", {
        confirmButtonText: "退回",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        showClose: false
      })
        .then(() => {
          returnContractApi({
            contractId: this.$route.query.contractId,
            signingBody: this.$route.query.signType,
            companyId: this.$route.query.companyId,
          })
            .then((res) => {
              if (res.code !== "0") {
                this.$message({
                  showClose: true,
                  message: res.message,
                  type: "warning",
                });
              } else {
                this.$message({
                  showClose: true,
                  message: "退回成功！",
                  type: "success",
                });

                setTimeout(() => {
                  this.$router.push({
                    path: "/",
                  });
                }, 2000);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
  },
};
</script>
<style scoped>
#sign-layer {
  background: #f0f0f5;
  height: 100vh;
  overflow: hidden;
}

header {
  width: 100%;
  height: 71px;
  background: rgba(35, 43, 58, 1);
  box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
  line-height: 71px;
  overflow: hidden;
}

.header-center {
  width: 1200px;
  margin: 0 auto;
  line-height: 71px;
  height: 71px;
  overflow: hidden;
  position: relative;
}

.logo {
  margin-top: 16px;
  margin-left: 0;
  width: 126px;
  float: left;
}

.logo-text {
  margin-left: 42px;
  font-size: 24px;
  color: #ffffff;
}

.logo-s-title {
  font-size: 24px;
  color: #ffffff;
  margin-left: 24px;
}

.return-index {
  height: 71px;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 24px;
  color: #ffffff;
  line-height: 71px;
}

.setcontrol-content {
  width: 1200px;
  margin: 30px auto 0;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.set-sign-control {
  width: 238px;
  background: white;
  position: relative;
  z-index: 9;
  overflow-y: auto;
  height: calc(100vh - 101px);
}

.set-title {
  font-size: 18px;
  height: 23px;
  line-height: 26px;
  color: #333333;
  border-left: 3px solid #e85052;
  text-indent: 13px;
  margin: 32px 0 0 27px;
}

.contract-img-content {
  /* height: calc(100vh - 134px);
												    overflow-y: auto;
												    position: relative; */

  /* position: absolute;
				left: 0;
				top: 0;
				right: 0;
				bottom: 0;
				z-index: 2; */

  height: 100%;
}

.contract-content {
  /* width: 685px; */
  background: white;
  /* position: relative; */
  height: calc(100vh - 101px);

  overflow-y: auto;
  overflow-x: hidden;
  /* overflow: auto; */
}

.contract-page {
  width: 238px;
  background: white;
  height: calc(100vh - 101px);
  /* overflow-y: auto; */
  /* overflow-x: hidden; */
}

.contract-imgs {
  position: relative;
  z-index: 1;
  background: #f0f0f5;
}

.contract-imgs .contract-img {
  display: block;
  width: 665px;
  height: auto;
  /* border-bottom: 2px solid #eee; */
  box-sizing: content-box;
  -ms-box-sizing: content-box;
}

.contract-imgs .orther-box-sign {
  max-width: 80px;
  max-height: 80px;
}

.contract-imgs .img-wrap {
  position: relative;
}

.contract-imgs .img-wrap+.img-wrap {
  margin-top: 30px;
}

/* .contract-img {
				width: 685px;
			} */

.custom-drag {
  width: 127px;
  height: 127px;
  border: 1px solid rgba(51, 204, 204, 1);
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  cursor: move;
  /* box-sizing: content-box;
												    -ms-box-sizing: content-box; */
}

.custom-content {
  width: 127px;
  height: 127px;
  background: rgba(255, 255, 255, 0.7);
  position: relative;
  z-index: 1;
}

.custom-drag-title {
  font-size: 16px;
  color: #000000;
  display: block;
  width: 127px;
  top: 50px;
  display: block;
  position: absolute;
  z-index: -1;
  text-align: center;
}

.custom-drag-time {
  position: absolute;
  bottom: 8px;
  text-align: center;
  font-size: 16px;
  color: #bbb;
  display: block;
  width: 127px;
  z-index: 9999;
}

.custom-drag-header {
  width: 109px;
  height: 33px;
  background: rgba(51, 204, 204, 1);
  line-height: 33px;
  font-size: 16px;
  color: #ffffff;
  padding: 0 10px;
  /* display: flex;
				justify-content: space-between; */
  position: absolute;
  left: -1px;
  top: -33px;
}

.custom-drag-header .delete {
  cursor: pointer;
  float: right;
  margin-right: 5px;
}

.custom-delete {
  font-size: 14px;
  width: 60px;
  height: 22px;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  color: #ffffff;
  display: block;
  line-height: 22px;
  position: absolute;
  left: 30px;
  bottom: -22px;
  display: none;
}

.all-page {
  width: 180px;
  margin: 30px auto 0;
}

.page-item {
  position: relative;
  height: 230px;
  margin-bottom: 22px;
}

.page-img {
  width: 177px;
  height: 198px;
  border: 1px solid rgba(240, 240, 245, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}

.page-img img {
  display: block;
  max-width: 177px;
  max-height: 198px;
}

.page-text {
  text-align: center;
  font-size: 14px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #333333;
}

.select-sign {
  width: 152px;
  margin: 45px auto 0;
}

.select-sign-title {
  font-size: 14px;
  color: #666666;
  text-align: center;
}

.sign-default,
.sign-orther {
  width: 152px;
  height: 152px;
  background: #f9f9f9;
  overflow: hidden;
  margin-top: 30px;
}

.sign-default-title {
  text-align: center;
  font-size: 14px;
  color: #999999;
  line-height: 34px;
}

.default-box,
.orther-sign-box {
  width: 80px;
  height: 80px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px auto 0;
  background: #ffffff;
  border: 1px solid rgba(229, 229, 229, 1);
  /* position: relative; */
}

.default-box img,
.orther-box .orther-box-sign {
  display: block;
  max-width: 80px;
  max-height: 80px;
  cursor: move;
}

/* .personal{
			background: url('../../assets/images/sign/personal.png') no-repeat right top;
			} */

.type-icon {
  position: relative;
  left: 88px;
  top: -81px;
  /* transform: translateY(-50px); */
}

.sign-name {
  font-size: 14px;
  color: #333333;
  text-align: center;
  line-height: 34px;
  margin-top: -6px;
}

.orther-title {
  text-align: center;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.sign-orther {
  width: 152px;
  margin: 15px auto 0;
}

.sign-orther {
  margin-top: 0;
}

.orther-box {
  margin-top: 20px;
  margin-bottom: 10px;
  height: 114px;
}

.orther-list {
  margin-top: 15px;
  padding-bottom: 40px;
}

.custom-sign-box {
  width: 127px;
  height: 127px;
  position: absolute;
  top: 0;
  left: 0;
  /* border: 1px solid red; */
  overflow: hidden;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-sign-box img {
  display: block;
  max-height: 127px;
  max-width: 127px;
}

.submit-btn {
  width: 336px;
  height: 50px;
  position: fixed;
  left: 50%;
  bottom: 50px;
  margin-left: -168px;
  color: #ffffff;
  font-size: 16px;
  z-index: 999;
}

.submit-btn button {
  width: 336px;
  height: 50px;
  font-size: 16px;
  float: left;
}

.page-img .sign-icon {
  width: 44px;
  height: 44px;
  position: absolute;
  right: 0;
  top: 0;
}

.sign-auth {
  text-align: center;
  font-size: 12px;
  color: red;
  margin-top: -40px;
  height: 17px;
}

.default {
  margin-top: -55px;
}

.drag-box /deep/ .delete-icon {
  font-size: 28px;
  position: absolute;
  color: #fff;
  font-weight: bold;
  right: -15px;
  top: -15px;
  display: none;
  cursor: pointer;
  background: red;
  border-radius: 50%;
}

.drag-box:hover /deep/ .delete-icon {
  display: block;
}
</style>